import { PAYMENT_COMP_UNIT, PAYMENT_BILLABLE, PAYMENT_COMP_CASH, PAYMENT_FREE } from '../../shop/constants';

export const ALL_RETURNS = 'all';
export const UNSUBMITTED_RETURNS = 'unsubmitted';

export const RETURN_AUTH_ID_KEY = 'returnAuthorizationIds';
export const DEPT_NAMES_KEY = 'departmentNames';
export const CREDIT_TYPE_KEY = 'creditType';
export const RETURN_STATUS_KEY = 'returnStatus';
export const PAGE = 'RETURN_STATUS';

export const DEFAULT_SORT = { field: 'dateSubmitted', order: 'DESC', page: PAGE };

export const PAGE_COUNT = 20;

export const RETURN_CREDIT_OPTIONS = [PAYMENT_COMP_UNIT, PAYMENT_BILLABLE, PAYMENT_COMP_CASH, PAYMENT_FREE];

export const sortbyMap = new Map([
  ['returnAuthorization', 'returnStatus.authNumber'],
  ['returnReference', 'returnStatus.returnReference'],
  ['creditType', 'returnStatus.creditType'],
  ['creditAmount', 'orderreturns.returnAmount'],
  ['submittedBy', 'global.submittedBy'],
  ['dateSubmitted', 'orderstatus.orderSubmittedDate'],
  ['dateExpired', 'returnStatus.dateExpires'],
  ['returnStatus', 'returnStatus.title']
]);

export const filterKeyMap = {
  returnAuthorizationIds: 'returnAuthorizationId',
  returnReferences: 'referenceId',
  submittedBys: 'createdBy'
};
